import { h, render } from 'preact';
import Widget from './widget';
import { defaultConfiguration } from './default-configuration';

if (window.attachEvent) {
    window.attachEvent('onload', injectChat);
} else {
    window.addEventListener('load', injectChat, false);
}

function injectChat() {
    if (!window.intergramId) {
        console.error('Please set window.intergramId (see github.com/idoco/intergram)');
        return;
    }

    const root = document.createElement('div');
    root.id = 'intergramRoot';
    document.getElementsByTagName('body')[0].appendChild(root);

    const server   = window.intergramServer || 'https://www.intergram.xyz';
    const iFrameSrc = server + '/chat.html';
    const host     = window.location.host || 'unknown-host';

    // Initial isMobile detection — Widget will override this reactively via
    // matchMedia listener on every breakpoint crossing (rotation, resize).
    // 667px matches Chatwoot's breakpoint (covers all phones incl. landscape).
    const isMobile = window.matchMedia('(max-width: 667px)').matches;

    const conf = {
        ...defaultConfiguration,
        ...window.intergramCustomizations,
        pageUrl: window.location.href
    };

    render(
        <Widget
            intergramId={window.intergramId}
            host={host}
            isMobile={isMobile}
            iFrameSrc={iFrameSrc}
            conf={conf}
        />,
        root
    );
}



// WEBPACK FOOTER //
// ./src/widget/widget-index.js